module.exports = __webpack_public_path__ + "img/Group_13.70520c07.svg";